<template>
  <div class="container-fluid">
    <router-link class="btn btn-circle torre-red" :to="{ name: 'productNew' }" title="Dodaj produkt">
      <i class="material-icons" >
      add
      </i>
    </router-link>
    <button v-if="isAdmin" type="button" class="btn btn-success btn-sm mr-2 torre-btn" @click="generateCsv" style="margin-bottom: 6px; margin-left: 6px;">
      generuj csv
    </button>
    <editable-item-popup
      v-if="isAdmin"
      title="Podaj nazwę"
    />
    <editable-item-price-popup
      v-if="isAdmin"
      title="Podaj cenę"
    />
    <product-group-popup />
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th scope="col" v-if="isAdmin">
              <check-actions/>
          </th>
          <th scope="col" class="align-top" >
            <div class="text-left input-group-sm align-top mb-2">
              <label >Ean</label>
            </div>
          </th>
          <th scope="col">
            <div class="input-group-sm mb-2">
              <label >Model telefonu</label>
              <input class="form-control" @keyup="onTextChanged" v-model="form.searchBrand"/>
            </div>
          </th>
          <th scope="col">
            <div class="input-group-sm mb-2">
              <label >Nazwa produktu</label>
              <search-input
                v-model="form.searchName"
                v-bind:items="productsNames"
                @onSearchInputKeyup="onTextChanged"
              />
              <!-- <input class="form-control" @keyup="onTextChanged" v-model="form.searchName"/> -->
            </div>
          </th>
          <th scope="col">
            <div class="input-group-sm mb-2">
              <label >Kolor</label>
              <select class="form-control" @change="handleFilterChange" v-model="form.colorId">
                <option v-for="option in colors" :key="option.id" v-bind:value="option.id">
                  {{ option.name }}
                </option>
              </select>
            </div>
          </th>
          <th scope="col">
            <div class="input-group-sm mb-2">
              <label >Kategoria</label>
              <select class="form-control" @change="handleFilterChange" v-model="form.categoryId">
                <option v-for="option in categories" :key="option.id" v-bind:value="option.id">
                  {{ option.name }}
                </option>
              </select>
            </div>
          </th>
          <th scope="col" class="align-top hide-mobile" >
            <div class="text-center input-group-sm align-top mb-2">
              <label >Cena</label>
            </div>
          </th>
          <th scope="col" class="align-top">
            <div class="text-center input-group-sm align-top mb-2">
              <label >Ilość</label>
            </div>
          </th>
          <th scope="col">
            <div class="input-group-sm mb-2">
              <label for="exampleInputEmail1">Status</label>
              <select class="form-control" @change="handleFilterChange" v-model="form.statusId">
                <option v-for="option in statuses" :key="option.id" v-bind:value="option.id">
                  {{ option.text }}
                </option>
              </select>
            </div>
          </th>
          <th v-if="isAdmin" scope="col" class="align-top hide-mobile">
            <div class="text-center">
              <label >Edycja</label>
            </div>
          </th>
          <th v-if="isAdmin" class="align-top hide-mobile">
            <div class="input-group-sm align-top mb-2">
              <label >Usuń</label>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
          <product-item-table
            v-for="item in products"
            :key="item.id"
            v-bind:product="item"
            />
      </tbody>
    </table>
    <div v-if="showEmptyResult" class="row">
      <div class="col text-center">
        Brak wyników
      </div>
    </div>
    <main-pagination @paginationClicked="onPaginationClicked"/>
  </div>
</template>

<script>

import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import un from 'underscore'
import uns from "underscore.string"
import ProductItemTable from '@/components/product/ProductItemTable'
import Vue from 'vue'
import MainPresenter from "@/service/MainPresenter"
import MainPagination from "@/components/pagination/MainPagination";
import checkActions from "@/components/utils/CheckActions";
import flashService from '@/service/flashService'
import alertify from 'alertifyjs';
Vue.component("main-pagination", MainPagination)
Vue.component('product-item-table', ProductItemTable)

export default {
  name: 'Main',
  components: {
    'check-actions': checkActions
  },
  data () {
    return {
      mainPresenter: new MainPresenter(),
      pageable: appConfig.pageableMainParams,
      statuses: appConfig.filterStatuses,
      loading: false,
      productsNames: [],
      form: {
        colorId: -1,
        categoryId: -1,
        statusId: 0,
        loggedStoreId: userService.getCurrentStore(),
        searchName: "",
        searchBrand: ""
      },
      products: [],
      categories: [{
        id: -1,
        name: "wszystkie"
      }],
      colors: [{
        id: -1,
        name: "wszystkie"
      }]
    }
  },
  created: function () {
    this.pageable.page = 0;
    this.loadColors();
    this.loadCategories();
    this.reloadContent();
    this.loadProductNames();
    this.$eventHub.$on('productNameUpdated', this.onProductNameUpdated);
    this.$eventHub.$on('productPriceUpdated', this.onProductPriceUpdated);
    this.$eventHub.$on('paginationClicked', this.onPaginationClicked);
    this.$eventHub.$on('refreshContent', this.onRefreshContent);
    this.$eventHub.$on('setCheckProduct', this.onSetCheckProduct);
  },
  destroyed() {
    this.$eventHub.$off('productPriceUpdated');
    this.$eventHub.$off('productNameUpdated');
    this.$eventHub.$off('paginationClicked');
    this.$eventHub.$off('refreshContent');
    this.$eventHub.$off('setCheckProduct');
  },
  mounted() {
    const msg = flashService.get("welcomeMsg");
    if (msg) {
      alertify.set('notifier','position', 'top-center');
      alertify.success(msg.text).delay(5);
    }
  },
  computed: {
    showEmptyResult() {
      return this.loading === false && this.products.length === 0
    },
    isAdmin() {
      return userService.isAdmin();
    }
  },
  methods: {
    generateCsv() {
      const formToSend = this.filterEndSpaces(this.form)
      let csvPageable = this.pageable
      csvPageable.size = 1000
      console.log(csvPageable)
      const req = axios({
        method: 'get',
        url: this.mainPresenter.getUrlForCsvData(formToSend, csvPageable),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        let disposition = res.headers["content-disposition"]
        const blob = new Blob([res.data], {
          type: "txt/csv",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = disposition.split('filename=')[1].split(';')[0];
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }).catch(e => {
        console.log('blad csv')
        console.log(e)
      })
    },
    onSetCheckProduct(value) {
      this.products = this.products
      .map(item => {
        var newItem = JSON.parse(JSON.stringify(item));
        newItem.productChecked = value
        return newItem
      })
    },
    loadProductNames: function () {
      const req = axios({
        method: 'get',
        url: appConfig.baseUrl + "/product/allNames/" + userService.getCurrentStore(),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      });
      req.then(res => {
        this.productsNames = res.data;
      }).catch(_ => {
        console.log("err");
      })
    },
    onRefreshContent: function() {
      this.reloadContent()
    },
    onProductNameUpdated: function(payload) {
      const editedproduct = payload.data
      const productOnList = un.find(this.products, function(item) {
        return item.id === editedproduct.id
      })
      productOnList.name = editedproduct.name
    },
    onProductPriceUpdated: function(payload) {
      const editedproduct = payload.data
      for (var i in this.products) {
        var item = this.products[i]
        if (item.id === editedproduct.id) {
          item = editedproduct
          break
        }
      }
    },
    onPaginationClicked: function(payload) {
      var pageToSend = payload.pageToSend;
      this.pageable.page = pageToSend;
      this.reloadContent();
    },
    handleFilterChange: function() {
      this.pageable.page = 0;
      this.reloadContent();
    },
    filterEndSpaces: function(form) {
      var f = JSON.parse(JSON.stringify(form));
      f.searchName = uns.trim(f.searchName)
      f.searchBrand = uns.trim(f.searchBrand)
      return f
    },
    onTextChanged: un.debounce(function (e) {
      this.pageable.page = 0;
      this.reloadContent();
    }, 300),
    reloadContent: function() {
      const formToSend = this.filterEndSpaces(this.form)
      this.loading = true
      const req = axios({
        method: 'get',
        url: this.mainPresenter.getUrlForData(formToSend, this.pageable),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.products = res.data.content;
        this.onSetCheckProduct(false)
        this.$eventHub.$emit('resetChecked');
        this.$emit('filterChanged', {
          data: res.data
        });
        this.loading = false
      }).catch(e => {
        console.log('blad products')
        this.loading = false
      })
    },
    loadColors: function() {
      const req = axios({
        method: 'get',
        url: this.mainPresenter.buildUrlWithDefaults("/colors"),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.colors = un.union(this.colors, res.data._embedded.colors);
      }).catch(_ => {
        console.log('blad colors')
      })
    },
    loadCategories: function() {
      const req = axios({
        method: 'get',
        url: this.mainPresenter.buildUrlWithDefaults("/categories"),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.categories = un.union(this.categories, res.data._embedded.categories);
      }).catch(_ => {
        console.log('blad categories')
      })
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Main.vue